import React, { useEffect, useState } from 'react';
import { get, ref } from 'firebase/database';
import { database } from '../firebaseConfig';

// Shows on "Confirm Photography" tasks: a Text Client button with an editable message.
// The agent enters the confirmed date and time, then sends the text from their phone. Nothing sends automatically.
const TEXT_BODY = 'Hi {{client_first_name}}, this is {{agent_first_name}}. I just wanted to let you know I confirmed the photography for {{photo_when}}.';

const fill = (text, data) => String(text || '').replace(/\{\{(\w+)\}\}/g, (m, k) => (data[k] == null ? '' : String(data[k])));

const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer' };
const btnOff = { ...btn, background: '#FFFFFF', color: '#B8962E', borderColor: '#D5D9E0', opacity: 0.5, cursor: 'not-allowed' };
const input = { padding: 8, borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 14, fontFamily: 'inherit', color: '#1A1A1A' };

export default function PhotographyClientText({ task, deal, client, ownerUid }) {
  const taskName = task.name || task.title || '';
  const isPhotoTask = /confirm photography/i.test(taskName);
  const [agent, setAgent] = useState(null);
  const [open, setOpen] = useState(false);
  const [when, setWhen] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!isPhotoTask || !ownerUid) return;
    get(ref(database, `users/${ownerUid}/profile`))
      .then((snap) => setAgent({ firstName: snap.exists() ? (snap.val().firstName || '') : '' }))
      .catch((err) => console.error('Could not load agent', err));
  }, [isPhotoTask, ownerUid]);

  if (!isPhotoTask) return null;

  const digits = (client?.phone || '').replace(/[^0-9+]/g, '');
  const clientFirst = client?.firstName || (client?.name || '').split(' ')[0] || '';

  const build = (whenText) => fill(TEXT_BODY, {
    client_first_name: clientFirst,
    agent_first_name: agent?.firstName || '',
    photo_when: whenText,
  });

  const toggle = () => {
    if (!open) {
      const defaultWhen = deal?.photographyDate || '';
      setWhen(defaultWhen);
      setMessage(build(defaultWhen));
    }
    setOpen(!open);
  };

  const updateWhen = (value) => {
    setWhen(value);
    setMessage(build(value));
  };

  return (
    <div style={{ margin: '6px 0' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 13, color: '#1A1A1A' }}>Client: <strong>{clientFirst || 'not set'}</strong>{digits ? ` · ${client.phone}` : ''}</span>
        <button type="button" onClick={toggle} disabled={!digits} style={digits ? btn : btnOff}>Text Client</button>
        {!digits && <span style={{ fontSize: 12, color: '#5B6270' }}>No phone saved for the client yet.</span>}
      </div>
      {open && digits && (
        <div style={{ marginTop: 8, padding: 10, border: '1px solid #D5D9E0', borderRadius: 8, background: '#FFFFFF' }}>
          <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Confirmed date and time</label>
          <input value={when} onChange={(e) => updateWhen(e.target.value)} placeholder="e.g., Tuesday, October 27 at 10:00 AM" style={{ ...input, width: '100%', boxSizing: 'border-box', marginBottom: 8 }} />
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={4} style={{ ...input, width: '100%', boxSizing: 'border-box' }} />
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <a href={`sms:${digits}?body=${encodeURIComponent(message)}`} style={btn}>Send text</a>
            <button type="button" onClick={() => setOpen(false)} style={{ ...btn, background: '#FFFFFF', color: '#5B6270', borderColor: '#D5D9E0' }}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
